export const styles = {
  link: {
    fontSize: 'inherit',
    textDecoration: 'none !important',
    '&:hover': {
      textDecoration: 'none !important',
    },
    '&:active': {
      textDecoration: 'none !important',
    },
  },
}
